module.exports = __webpack_public_path__ + "img/success-solid.a7b21e7f.svg";